import { z } from 'zod';

/** Letters and spaces only (names). Case is preserved; the field caps length at 50 via antd `maxLength`. */
const NAME_RE = /^[A-Za-z ]+$/;

/** One person-name field (internal User, Dealer): trim, collapse internal runs of whitespace to a
 *  single space, then validate letters+spaces, 1–50 → "Enter a valid name". Lives in `lib` so a
 *  node-project schema test in any feature can load it without a React barrel. */
export const nameFieldSchema = z
  .string()
  .trim()
  .transform((value) => value.replace(/\s+/g, ' '))
  .pipe(
    z
      .string()
      .min(1, 'Enter a valid name')
      .max(50, 'Enter a valid name')
      .regex(NAME_RE, 'Enter a valid name'),
  );
